//#region Frax

const fraxActions = {
    ADD: 0,
    REMOVE: 2,
    RENAME: 5
};
const fraxEvents = {
    SELECTED: 'frax-selected',
    DESELECTED: 'frax-deselected',
    CHANGED: 'frax-changed',
}
var Frax = {
    richt: {},
    data: {},
    ids: [],
    selectType: {
        "SELECT": "SELECT",
        "DESELECT": "DESELECT",
    },
    selectionCallback: {},
    initialize: function (id, multiselect = false, draggable = false, strings, forceEnabledCheckboxesOnStartP = false) {
        this.ids.push(id)
        let $control = $('#' + id)
        let self = this;
        //let single_select_props = {
        //    'deselect_all': true,
        //    'three_state': false
        //};
        //if (multiselect) single_select_props = {};

        $control.bind('ready.jstree', function (e, data) {
            if (Frax.richt[id] != undefined) {
                Frax.richt[id]();
            }

            if (convert.stringToBoolean(multiselect) === true && convert.stringToBoolean(forceEnabledCheckboxesOnStartP) === true) {
                data.instance.show_checkboxes()
                data.instance.settings.core.multiple = true
            }
        })

        //$control.on(
        //    "select_node.jstree", function (evt, data) {
        //        //selected node object: data.node;
        //        //console.log(11111)
        //        //console.log(evt)
        //        //console.log(data)
        //    }
        //);

        $control.bind('select_node.jstree', function (node, selected, event) {
            $control.trigger({
                type: fraxEvents.SELECTED,
                selectedNode: selected
            })
        })

        $control.bind('deselect_node.jstree', function (node, selected, event) {
            $control.trigger({
                type: fraxEvents.DESELECTED,
                selectedNode: selected
            })
        })

        $control.bind('changed.jstree', function (node, selected, event) {
            $control.trigger({
                type: fraxEvents.CHANGED,
                event: event
            })
        })

        if (draggable) {
            $control.bind("move_node.jstree", function (event, data) {
                let $frax = $(this).closest('.kdr-frax')
                let $loadingTargets = $frax
                let args = {
                    sourceValue: data.node.a_attr["data-value"],
                    targetValue: data.parent != '#' ? $('#' + data.parent + '_anchor').data('value') : null
                }

                $.ajax({
                    type: "POST",
                    url: __root + "Frax/Act",
                    datatype: "json",
                    traditional: true,
                    data: {
                        info: controls.getInfo($frax),
                        magic: data.node.a_attr["data-magic"],
                        args: JSON.stringify(args)
                    },
                    success: function (response) {

                        if (response.info == null) {
                            response.info = controls.getInfo($frax)
                        }

                        controls.magic(controls.getEndpoint($frax), $frax, response, $loadingTargets, true);
                    },
                    beforeSend: function () { loading.show($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.attr('disabled', 'disabled') },
                    complete: function () { loading.hide($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.removeAttr('disabled') }
                });
            })
        }

        $control.jstree({
            "checkbox": {
                "keep_selected_style": true,
                "three_state": false,
                "whole_node": false, //nerwic julki
                "visible": false
                /*"cascade_to_disabled": false,*/
                /*"tie_selection": false*/
                //...single_select_props
            },
            //"plugins": ["search", "conditionalselect", props.multiselect ? "checkbox" : "", "dnd"],
            "plugins": ["search", "conditionalselect", multiselect ? "checkbox" : "", draggable ? "dnd" : ""],
            'core': {
                "check_callback": true,
                'multiple': false,
                'data': self.data[id],
                'check_callback': function (operation, node, node_parent, node_position, more) {
                    if (operation === 'move_node' && more.ref) {
                        return Boolean(node.a_attr['data-draggable-out-p']) && Boolean(more.ref.a_attr['data-draggable-in-p'])
                    }
                    return true
                },
                'strings': strings
            },
            "search": {
                "case_sensitive": false,
                "show_only_matches": true,
                'show_only_matches_children': true
            }
        });
        if (this.selectionCallback[id])
            this.registerSelectionCallback(id, this.selectionCallback[id]);
    },
    destroy: function (id) {
        $("#" + id).jstree("destroy");
    },
    getSelected: function (id) {
        return $("#" + id).jstree("get_selected");
    },
    registerSelectionCallback: function (id, callback) {
        let self = this;
        this.selectionCallback[id] = callback;
        $("#" + id).on(
            "select_node.jstree", function (evt, data) {
                callback(evt, data, self.selectType.SELECT);
            }
        );
        $("#" + id).on(
            "deselect_node.jstree", function (evt, data) {
                callback(evt, data, self.selectType.DESELECT);
            }
        );
    },
    scrollToSearched($fraxSearch) {
        let $frax_search = $fraxSearch
        let $frax = $('#' + $frax_search.attr('data-control-id'));
        let isAnyScrolled = $frax.find('.jstree-scroll-to').length > 0
        let $scrollToElement;
        let $scrollContainer = $frax.find('.jstree-container-ul')

        if (isAnyScrolled === true && $frax.find('.jstree-search').length > 1) {
            let $scrollPosibilities = $frax.find('.jstree-search')
            let scrolledIndex = $.inArray($frax.find('.jstree-scroll-to')[0], $scrollPosibilities)
            if (scrolledIndex == -1 || (scrolledIndex == $frax.find('.jstree-search').length - 1)) {
                $scrollToElement = $scrollPosibilities.eq(0)
            } else {
                $scrollToElement = $scrollPosibilities.eq(scrolledIndex + 1)
            }
            $frax.find('.jstree-scroll-to').removeClass('jstree-scroll-to')

        } else {
            $scrollToElement = $frax.find('.jstree-search').eq(0)
        }
        $scrollToElement.addClass('jstree-scroll-to')

        $scrollContainer.scrollTop(0).scrollTop($scrollToElement.getPositionInViewport().top - $frax.getPositionInViewport().top)
    },
    lazyInitialize: function () {
        return 0
        //FIXME SYF
        //for (let i = 0; i < Frax.ids.length; ++i) {
        //    let id = Frax.ids[i];

        //    let magicRelations = magic_relations.filter(function (el) {
        //        if (el.source == id.substr(1))
        //            return true;
        //    });
        //    if (magicRelations) {
        //        this.registerSelectionCallback(id, (evt, data) => {
        //            for (let i = 0; i < magicRelations.length; i++) {
        //                let id = data.node.id;
        //                let control = $("#" + magicRelations[i].target);
        //                let controlType;
        //                if (control.hasClass('kdr-grid')) controlType = 'Grid';
        //                else if (control.hasClass('kdr-frax')) controlType = 'Frax';
        //                loading.show(control);
        //                let args = {}
        //                args[$("#" + Frax.ids[i].substr(1)).attr("data-index")] = id;

        //                $.ajax({
        //                    type: "POST",
        //                    url: __root + "Filters/Filter",
        //                    datatype: "json",
        //                    traditional: true,
        //                    data: {
        //                        "control": control.find(".kdr-info").val(),
        //                        "args": JSON.stringify(args)
        //                    },
        //                    success: function (response) {
        //                        controls.magic(controlType + "/Render", control, response)
        //                    }
        //                })
        //            }

        //        });
        //    }
        //}
    },
    rename($frax, $tree, $loadingTargets, magic) {
        $tree.jstree().edit($tree.jstree("get_selected"), null, function (node) {
            let args = {
                nodeName: node.text
            }

            $.ajax({
                type: "POST",
                url: __root + "Frax/Act",
                datatype: "json",
                traditional: true,
                data: {
                    info: controls.getInfo($frax),
                    magic: magic,
                    args: JSON.stringify(args)
                },
                success: function (response) {
                    controls.onGridBeforeRender($frax, response.code, fraxActions.RENAME, response.info, response.returnValue)
                    controls.magic(controls.getEndpoint($frax), $frax, response, $loadingTargets);
                },
                beforeSend: function () { loading.show($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.attr('disabled', 'disabled') },
                complete: function () { loading.hide($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.removeAttr('disabled') }
            })
        })
    },
    /**
     *
     * @param {button} $triggerComponent element ktory wywoluje dropdownliste z fraxem
     */
    checkIfValuesHasChangedInFraxDDL($triggerComponent) {
        let dropdownId = '#' + $triggerComponent.data('target')
        let $fraxTree = $(dropdownId).find('.kdr-frax--tree')

        let currentItems = $fraxTree.valExtended()
        let previousItems = $fraxTree.data('oldValue') ?? []

        if ($fraxTree.hasClass('kdr-frax-multi-select') && compare.arraysAreEqual(currentItems, previousItems) == false) {
            $triggerComponent.trigger('change')
        } else if ($fraxTree.hasClass('kdr-frax-single-select') && currentItems != previousItems) {
            $triggerComponent.trigger('change')
        }
    }
};

$(document).on("keyup", ".kdr-frax-search", function (e) {
    let $frax_search = $(e.target);
    let $frax = $('#' + $frax_search.attr('data-control-id'));

    if (e.keyCode != 13) {
        if (window.frax_throttle) clearTimeout(window.frax_throttle);
        window.frax_throttle = setTimeout(function () {
            let v = $frax_search.val();
            $frax.jstree(true).search(v);
            Frax.scrollToSearched($frax_search)
        }, 250);
    } else {
        Frax.scrollToSearched($frax_search)
    }
});

$(document).on(fraxEvents.SELECTED, '.kdr-filters .kdr-frax-single-select, .kdr-grid .kdr-frax-single-select, .kdr-form-preview .kdr-frax-single-select', function ($node) {
    let $frax = $(this)
    let dropdownId = $frax.closest('.dropdown-menu').prop('id')
    let $dropdownContainer = $('[data-target="' + dropdownId + '"]').closest('.kdr-frax-dropdown')

    $dropdownContainer.find('.kdr-frax-dropdown-selected-item').text($node.selectedNode.node.text)
    $frax.closest('.kdr-frax-dropdown-menu').dropdown('hide')
})

$(document).on(fraxEvents.SELECTED, '.kdr-filters .kdr-frax-multi-select, .kdr-grid .kdr-frax-multi-select', function ($node) {
    let $frax = $(this)
    let dropdownId = $frax.closest('.dropdown-menu').prop('id')
    let $dropdownContainer = $('[data-target="' + dropdownId + '"]').closest('.kdr-frax-dropdown')

    $dropdownContainer.find('.kdr-frax-dropdown-item_selected').data('value', $frax.jstree('get_checked'))
    let $destination = $dropdownContainer.find('.kdr-frax-dropdown-item_selected')

    $($dropdownContainer.find('.kdr-frax-dropdown-item_selected').data('value')).each((a, b) => {
        if ($dropdownContainer.find('.items_selected-text-item[data-value=' + b + ']').length == 0) {
            let $node = $frax.jstree('get_node', b)
            let $c = $destination.find('.items_selected-text-item-pattern').clone().detach()
            $c.find('.dismiss-item').before($node.text)
            $c.attr('data-value', $node.id)
            $destination.find('.item_selected-content-wrapper .items_selected-text').append($c)
            $c.removeClass('items_selected-text-item-pattern')
        }
    })

    let values = $dropdownContainer.find('.kdr-frax-dropdown-item_selected').data('value')

    $dropdownContainer.find('.items_selected-text-item:not(.items_selected-text-item-pattern)').each((a, b) => {
        if (!values.includes($(b).data('value').toString())) {
            $(b).remove()
        }
    })

    let selectedItemsCount = $dropdownContainer.find('.kdr-frax-dropdown-item_selected').data('value').length
    $dropdownContainer.find('.items_selected_count').text(selectedItemsCount)
    $dropdownContainer.find('.kdr-frax-trigger-target').attr('data-selected-items-count', selectedItemsCount)
})

$(document).on(fraxEvents.DESELECTED, '.kdr-filters .kdr-frax-multi-select, .kdr-grid .kdr-frax-multi-select', function ($node) {
    let $fraxTree = $(this)
    let dropdownId = $fraxTree.closest('.dropdown-menu').prop('id')
    let $dropdown = $('[data-target="' + dropdownId + '"]').closest('.kdr-frax-dropdown')

    $dropdown.find('.kdr-frax-dropdown-item_selected').data('value', $fraxTree.valExtended())
    /*let $destination = $dropdown.find('.kdr-frax-dropdown-item_selected')*/
    $dropdown.find('.items_selected-text-item[data-value=' + $node.selectedNode.node.id + ']').remove()

    let selectedItemsCount = $dropdown.find('.kdr-frax-dropdown-item_selected').data('value').length
    $dropdown.find('.items_selected_count').text(selectedItemsCount)
    $dropdown.find('.kdr-frax-trigger-target').attr('data-selected-items-count', selectedItemsCount)
})

$(document).on('click', '.kdr-frax .jstree-anchor:not(.jstree-disabled)', function () {
    let $that = $(this)
    let $frax = $that.closest(".kdr-frax")

    controls.invokeCommands($frax)

    //let inputs = $frax.find('.jstree-anchor.jstree-clicked')
    ////let inputs = $frax.jstree("get_selected")
    //let args = {}
    //controls.getArgs(inputs, args)
});

$(document).on('click', '.kdr-frax-act', function () {
    let $that = $(this)
    let $frax = $that.closest(".kdr-frax")
    let $loadingTargets = $frax

    $.ajax({
        type: "POST",
        url: __root + "Frax/Act",
        datatype: "json",
        traditional: true,
        data: {
            "info": controls.getInfo($frax),
            "magic": $that.attr("data-magic"),
        },
        success: function (response) {
            controls.onGridBeforeRender($frax, response.code, fraxActions.ADD, response.info, response.returnValue)
            controls.magic(controls.getEndpoint($frax), $frax, response, $loadingTargets);
        },
        beforeSend: function () { loading.show($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.attr('disabled', 'disabled') },
        complete: function () { loading.hide($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.removeAttr('disabled') }
    })
});

$(document).on('click', '.kdr-frax-act-remove', function () {
    let $that = $(this)
    let $frax = $that.closest(".kdr-frax")
    let $modal = $frax.find(".kdr-frax-delete-modal").clone().detach()
    let mId = $modal.prop('id') + 'clonedDetached'
    let $loadingTargets = $frax

    $modal.prop('id', mId)
    $('body').append($modal)

    modal.prepareModal(mId);

    $modal.on('hidden.bs.modal', function () {
        $modal.remove()
    })

    let args = { selected: $frax.find('.kdr-frax--tree').jstree().get_selected() }

    $modal.find('.modal-body').append('<ul>' + $('#_documents-frax').jstree().get_selected().map(a => '<li>' + $('#' + a).text() + '</li>').join('') + '</ul>')

    $modal.find(".kdr-grid-remove-confirm").click(function () {
        $modal.modal("hide")
        $.ajax({
            type: "POST",
            url: __root + "Frax/Act",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($frax),
                "magic": $that.attr("data-magic"),
                "args": JSON.stringify(args)
            },
            success: function (response) {
                controls.onGridBeforeRender($frax, response.code, fraxActions.REMOVE, response.info, response.returnValue)
                controls.magic(controls.getEndpoint($frax), $frax, response, $loadingTargets);
            },
            beforeSend: function () { loading.show($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.attr('disabled', 'disabled') },
            complete: function () { loading.hide($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.removeAttr('disabled') }
        })
    })
    $modal.modal("show")
});

$(document).on("click", ".kdr-frax-rename", function () {
    let $this = $(this)
    let $frax = $this.closest(".kdr-frax")
    let $tree = $frax.find('.kdr-frax--tree')

    if ($tree.jstree().get_selected(true) &&
        $tree.jstree().get_selected(true)[0] &&
        $tree.jstree().get_selected(true)[0].state.checkbox_disabled === false) {
        Frax.rename($frax, $tree, $frax, $this.attr("data-magic"))
    }
    else {
        modal.getModal.danger(
            frax_default_translated_strings['Error'],
            frax_default_translated_strings['You do not have sufficient privileges to rename selected element.%{UserMessages}'],
            true)
    }
})

$(document).on("click", ".kdr-frax-toggle-checkboxes", function () {
    let $this = $(this)
    let $frax = $this.closest(".kdr-frax")
    let $tree = $frax.find('.kdr-frax--tree')
    let stateP = !$frax.find('.jstree-container-ul').hasClass('jstree-no-checkboxes')

    if (stateP) {
        let firstCheckedNode = $tree.jstree().get_checked()[0] ?? ''
        $tree.jstree().hide_checkboxes()
        $tree.jstree().uncheck_all()
        $tree.jstree().check_node(firstCheckedNode)
        $this.removeClass('color-user-primary')
    } else {
        $tree.jstree().show_checkboxes()
        $this.addClass('color-user-primary')
    }

    $tree.jstree().settings.core.multiple = !stateP
})

$(document).on(gridEvents.BEFORE_RENDER, "#documents-frax", function (response) {
    if (response.code == gridResponseCodes.SUCCESS && response.actionType == fraxActions.ADD) {
        $(document).one(gridEvents.AFTER_RENDER, "#documents-frax", function () {
            let $frax = $(this)
            let $tree = $frax.find('.kdr-frax--tree')
            let renameMagic = $frax.find(".kdr-frax-rename").attr("data-magic")

            $frax.find('[data-identity-p="true"]').click()
            Frax.rename($frax, $tree, $frax, renameMagic)
        })
    }
    if (response.code == gridResponseCodes.SUCCESS
        && (response.actionType == fraxActions.RENAME || response.actionType == fraxActions.REMOVE)) {
        controls.refresh(null, 'documents-detail')
    }
})

$(document).on('show.bs.dropdown hide.bs.dropdown', '.kdr-frax-dropdown', function (e) {
    let $dismissItem = $(e.target).find('.dismiss-item:hover')
    if ($dismissItem.length > 0) {
        e.preventDefault()
        e.stopPropagation()
        /*kdrDropdown.removeSelectedItem($dismissItem)*/
        let $this = $dismissItem.closest('.items_selected-text-item')
        let $frax = $this.closest(".kdr-frax-dropdown")

        let $triggerComponent = $frax.find('.dropdown-toggle')
        let dropdownId = '#' + $triggerComponent.data('target')
        let $fraxTree = $(dropdownId).find('.kdr-frax--tree')

        $fraxTree.jstree().uncheck_node($this.data('value'))

        $frax.find('.kdr-frax-dropdown-item_selected').data('value', $fraxTree.jstree('get_checked'))

        let selectedItemsCount = $frax.find('.kdr-frax-dropdown-item_selected').data('value').length

        $frax.find('.items_selected_count').text(selectedItemsCount)
        $triggerComponent.attr('data-selected-items-count', selectedItemsCount)
    }
})

$(document).on('show.bs.dropdown', '.kdr-frax-dropdown', function (e) {
    let $dropdownContainer = $(this)

    if ($dropdownContainer.data('shouldntOpen') === true) {
        e.preventDefault()
        $dropdownContainer.data('shouldntOpen', false)
    }

    let $triggerComponent = $dropdownContainer.find('.kdr-frax-trigger-target')
    let dropdownId = '#' + $triggerComponent.data('target')
    let $dropdown = $(dropdownId)

    let $fraxTree = $dropdown.find('.kdr-frax--tree')
    let currentItems = $fraxTree.valExtended()

    $fraxTree.data('oldValue', currentItems)
    $dropdown.data('toggler', $triggerComponent)

    kdrDropdown.updatePosition($dropdown)
})

$(document).on('hide.bs.dropdown', '.kdr-frax-dropdown', function (e) {
    let $t = $(this)
    let $triggerComponent = $t.find('.kdr-frax-trigger-target')

    Frax.checkIfValuesHasChangedInFraxDDL($triggerComponent)
    $t.data('shouldntOpen', true)
})

/////////////////////////////
//     Frax folders        //
/////////////////////////////
function fraxFolderNodeState(object) {
    this.opened = object.opened
    this.disabled = object.disabled
    this.checkbox_disabled = object.checkbox_disabled
    this.selected = object.selected
}
function fraxFolderNodeAttributesModel(object) {
    this.dataValue = object['dataValue']
    this.draggableOutP = object['draggableOutP']
    this.draggableInP = object['draggableInP']
    this.removableP = object['removableP']
}
function fraxFolderNodeImage(object) {
    this.src = object.nodeImage;
    /** 
     * 1 -> img
     * 2 -> font awesome icon
     * 3 -> magic img
     * */
    this.imageType = object.nodeImageType;
    this.hasAnyImage = () => this.src != undefined && this.src.length > 0
}
function fraxNodeActionButton(object) {
    this.tooltip = object.tooltip
    this.icon = object.icon
    this.classes = object.classes
    this.selectedItemClasses = object.selectedItemClasses
}
function fraxFolderNodeModel(object) {
    this.groupKey = object.groupKey;
    this.id = object.id;
    this.parent = object.parent;
    this.description = object.description;
    this.text = object.text;
    this.likes = object.likes;
    this.comments = object.comments;
    this.views = object.views;
    this.saves = object.saves;
    this.outerClass = object.outerClass;
    this.epics = object.epics;
    this.path = object.path;
    this.content = object.content;
    this.fileNames = object.fileNames;
    this.publicatedP = object.publicatedP;
    this.archivedP = object.archivedP;
    /** 
     * @type {Array<fraxNodeActionButton>}
     */
    this.nodeActionButtons = object.nodeActionButtons
    this.childrenCount = object.nodeChildrenCount
    this.image = new fraxFolderNodeImage(object)
    this.state = object.state;
    this.attributes = new fraxFolderNodeAttributesModel(object.attributes)
}

const fraxFolder = {
    classes: {
        itemImgContainer: 'kdr-frax-folder-item-image-container',
        itemImg: 'kdr-frax-folder-item-image',
        itemDraggableOut: 'kdr-frax-folder-item-draggable-out',
        itemDraggableIn: 'kdr-frax-folder-item-draggable-in',
    },
    events: {
        downloadFraxFolderItem: "fraxFolderDownloadItem"
    },
    currentDraggableItem: null,
    /**
     * Wyszukuje zaznaczonego obecnie node`a 
     * @param {any} $fraxFolder frax w ktorym szukamy
     * @returns {fraxFolderNodeModel} znaleziony node lub undefined jezeli takowego nima
     */
    getSelectedNode: ($fraxFolder) => fraxFolder.getStructure($fraxFolder).filter(x => x.state.selected === true)[0],
    getSelectedNodeValue: ($fraxFolder) => new fraxFolderNodeModel(fraxFolder.getSelectedNode($fraxFolder)).attributes.dataValue,
    /**
     * Wyszukuje node'a w strukturze danego fraxa
     * @param {any} $fraxFolder frax w ktorym szukamy
     * @returns {fraxFolderNodeModel} znaleziony node lub undefined jezeli takowego nima
     */
    getNodeFromStruct: ($fraxFolder, nodeId) => fraxFolder.getStructure($fraxFolder).filter(x => x.id === nodeId)[0],
    /**
     * Pobiera strukture danego fraxa
     * @param {any} $fraxFolder frax w ktorym szukamy
     * @returns {[fraxFolderNodeModel]} znaleziona struktura
     */
    getStructure: ($fraxFolder) => $fraxFolder.data('structure'),
    getNodeChildrens: ($fraxFolder, nodeId) => fraxFolder.getStructure($fraxFolder).filter(x => x.parent == nodeId),
    getNodeParent: ($fraxFolder, parentId) => fraxFolder.getStructure($fraxFolder).filter(x => x.id == parentId)[0],
    /**
     * Wyszukuje templaty html'owe danego fraxa
     * @param {any} $fraxFolder frax w ktorym szukamy
     * @returns Znalezione templaty
     */
    getTemplates: ($fraxFolder) => {
        return {
            selectedItem: $fraxFolder.data('templates').selectedItem,
            noData: $fraxFolder.data('templates').noData,
            breadcrumb: $fraxFolder.data('templates').breadcrumb,
            item: $fraxFolder.data('templates').item
        }
    },
    selectNode($fraxFolder, selectedItemId, triggerEventP = true) {
        let currentlySelectedNode = fraxFolder.getSelectedNode($fraxFolder)

        let newNode = fraxFolder.getNodeFromStruct($fraxFolder, selectedItemId)
        currentlySelectedNode.state.selected = false
        newNode.state.selected = true

        fraxFolder.renderBreadCrumbs($fraxFolder, newNode)
        fraxFolder.renderSelectedNode($fraxFolder, new fraxFolderNodeModel(newNode))
        fraxFolder.renderSelectedNodeStructure($fraxFolder, newNode)

        if (triggerEventP === true) {
            $fraxFolder.trigger({
                type: fraxEvents.SELECTED,
                selectedItemId: selectedItemId
            })
        }
    },
    /**
     * Renderuje breadcrumby wg. template'u
     * @param {any} $frax
     * @param {fraxFolderNodeModel} selectedNode
     */
    renderBreadCrumbs($frax, selectedNode) {
        let nodeParentStruct = [selectedNode];

        /**
         * buduje sciezke do wybranego node'a
         * @param {fraxFolderNodeModel} node
         */
        function _buildPath(node) {
            let p = fraxFolder.getNodeParent($frax, node.parent)
            if (p != undefined && p.length != 0) {
                nodeParentStruct.push(p)
                _buildPath(p)
            }
        }
        _buildPath(selectedNode)

        let $breadcrumbsContainer = $frax.find('.kdr-frax-folder-breadcrumbs');
        let childsToRender = []

        for (var i = nodeParentStruct.length; i > 0; i--) {
            //let n = nodeParentStruct[i - 1]
            let $n = new fraxFolderNodeModel(nodeParentStruct[i - 1])
            let $b = $($.parseHTML(templates.breadcrumb.trim()))

            $b.find('a').html($n.text).attr('title', $n.text)
            $b.find('a').data('p', $n.id)

            if ($n.attributes.draggableInP) {
                $b.addClass(fraxFolder.classes.itemDraggableIn)
            }

            childsToRender.push($b)
        }

        if (childsToRender.length > 2) {
            let $dotsElement = $($.parseHTML(templates.breadcrumb.trim()))
            $dotsElement.find('a').addClass('kdr-frax-folder-breadcrumb-ignore').html($dotsElement.find('.fa-folder-open').removeClass('fa-folder-open').addClass('fas fa-ellipsis-h')).attr('title', __l.ClickToShowBreadcrumbs)
            $dotsElement.addClass('kdr-frax-folder-breadcrumb-parent-dots')

            $frax.find('.kdr-frax-folder-breadcrumbs').addClass('kdr-frax-folder-breadcrumbs-short')

            childsToRender = childsToRender.toSpliced(1, 0, $dotsElement);
        }

        if (nodeParentStruct.length < 2) {
            $breadcrumbsContainer.find('.kdr-frax-folder-up').fadeOut()
        }
        else {
            $breadcrumbsContainer.find('.kdr-frax-folder-up').fadeIn()
        }

        $breadcrumbsContainer.find('.kdr-frax-folder-breadcrumb-parent').remove()
        $breadcrumbsContainer.append(childsToRender)

        $('.tooltip').remove()

        tooltipHelper.init($breadcrumbsContainer)
        tooltipHelper.init($('.kdr-frax-folder-breadcrumb-parent-dots svg'))

        fraxFolder.initializeDragAndDropFraxFolders($frax, $(childsToRender));
    },
    /**
     * Renderuje wybranego node'a wg. template'u
     * @param {any} $frax
     * @param {fraxFolderNodeModel} selectedNode
     */
    renderSelectedNode($frax, selectedNode) {
        let templates = fraxFolder.getTemplates($frax)
        let $selecteditemInner = $($.parseHTML(templates.selectedItem.trim()))

        let $selectedItemContainer = $frax.find('.kdr-frax-folder-selected-item')

        let $itemDescContainer = $selecteditemInner.find('.kdr-frax-folder-selected-item-desc')

        if (textHelper.isNullOrEmpty(selectedNode.description) === false) {
            $itemDescContainer.html(`${selectedNode.description}`)
            $selectedItemContainer.show()
        } else {
            $itemDescContainer.html(templates.noData.trim())
            $selectedItemContainer.hide()
        }

        let $tConditionalBtnsContainer = $frax.find('.kdr-frax-folder-selected-item-action-buttons-conditional')

        fraxFolder.renderSelectedNodeActionButtons($selectedItemContainer, $tConditionalBtnsContainer, selectedNode.nodeActionButtons, selectedNode.attributes.removableP)

        $selectedItemContainer.data('p', selectedNode.attributes.dataValue)

        setTimeout(() => $selectedItemContainer.html($selecteditemInner), 0)
    },
    /**
     * Renderuje strukture wybrangeo node'a
     * @param {any} $frax
     * @param {fraxFolderNodeModel} selectedNode
     */
    renderSelectedNodeStructure($frax, selectedNode) {
        let templates = fraxFolder.getTemplates($frax)
        let $groups = $frax.find('.kdr-frax-folder-items-group')
        let selectedNodeChildrens = fraxFolder.getNodeChildrens($frax, selectedNode.id)
        let groupedChildrenNodes = arrayHelper.groupBy(selectedNodeChildrens, "groupKey") ?? []
        let allRenderedChildrens = $()
        let hiddenGroupsCount = 0;
        $groups.each((i, e) => {
            let $group = $(e)
            let $groupRenderPlace = $group.find('.kdr-frax-folder-group')
            let groupKey = $group.data('groupKey')
            let itemsAreBigP = convert.stringToBoolean($group.data('itemsAreBigP'))
            let itemsAreClickableP = convert.stringToBoolean($group.data('itemsAreClickableP'))

            let childs = groupedChildrenNodes[groupKey]

            if (childs == undefined || childs.length == 0) {
                hiddenGroupsCount++

                setTimeout(() => {
                    $group.hide()
                    $groupRenderPlace.html(templates.noData.trim())
                }, 0)
            } else {
                $group.show()

                let childsToRender = []
                for (var i = 0; i < childs.length; i++) {
                    let c = new fraxFolderNodeModel(childs[i])
                    let $t = $($.parseHTML(templates.item.trim()))

                    $t.data('p', c.id)
                    $t.find('.kdr-frax-folder-item-name').html(c.text)
                    $t.find('.kdr-frax-folder-item-description').html(c.description)

                    let tooltip = `<b>${c.text}</b>`;
                    if (textHelper.isNullOrEmpty(c.description) === false) {
                        tooltip += `<div class="text-left">${c.description}</div>`
                    }

                    $t.find('.kdr-frax-folder-item-tooltip').attr('title', tooltip)

                    if (itemsAreBigP === true) {
                        $t.addClass('kdr-frax-folder-item-big')
                    }

                    if (itemsAreClickableP === true) {
                        $t.addClass('kdr-frax-folder-item-clickable')
                    }

                    if ($frax.hasClass('kdr-frax-folder-alternative')) {
                        if (c.archivedP == true) {
                            $t.addClass('kdr-frax-folder-item-outline')
                            $t.append(`<div class="kdr-frax-folder-item-outline-wrapper" style="border: 1px solid #c3c3c3;"><span class="kdr-frax-folder-item-outline-desc">` + __l.Archived + `</span></div>`)
                        }
                        else if (c.publicatedP == false) {
                            $t.addClass('kdr-frax-folder-item-outline')
                            $t.append(`<div class="kdr-frax-folder-item-outline-wrapper"><span class="kdr-frax-folder-item-outline-desc">` + __l.WaitingForPublication + `</span></div>`)
                        }
                    }

                    if (c.epics != null) {
                        let $epicsContainer = $t.find('.kdr-frax-article-item-epics')
                        let hiddenTooltip = "";
                        let counter = 0;

                        for (let i = 0; i < c.epics.length; i++) {
                            if (i < 2)
                            {
                                let rgbColor = convert.hexToRgbString(c.epics[i].colorHex)

                                let color = checkColor.isDark(rgbColor) ? "#fff" : "#000"
                                $epicsContainer.append($(`<p style="display: inline-block;margin-right: 0.3rem;padding: 0.2rem 0.5rem;border-radius: 5px;background-color:${c.epics[i].colorHex};color:${color};white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 7rem" data-toggle="tooltip" data-html="true" data-placement="top" title="" data-original-title="${c.epics[i].name}"></p>`).text(c.epics[i].name))
                            }
                            else
                            {
                                hiddenTooltip += c.epics[i].name + ' <br>'
                                counter++
                            }

                        }

                        if (hiddenTooltip.length > 1) {
                            $epicsContainer.append($(`<p style="display: inline-block;margin-right: 0.3rem;padding: 0.2rem 0.5rem;border-radius: 5px;background-color:#34346A20;color:#34346A" data-toggle="tooltip" data-placement="top" title="" data-original-title="${hiddenTooltip}"></p>`).text('+' + counter))
                        }
                    }

                    if ($frax.hasClass('kdr-frax-folder-alternative')) {
                        $t.find('.kdr-frax-folder-item-likes-count').text(c.likes)
                        $t.find('.kdr-frax-folder-item-comments-count').text(c.comments)
                        $t.find('.kdr-frax-folder-item-views-count').text(c.views)
                        $t.find('.kdr-frax-folder-item-saves-count').text(c.saves)

                        $t.addClass(' ' + c.outerClass)

                        if ($t.hasClass('kdr-frax-folder-new-catalog') || $t.hasClass('kdr-frax-folder-new-article')) {
                            $t.removeClass('kdr-frax-folder-item-clickable')
                        }
                    }

                    if (c.attributes.draggableInP) {
                        $t.addClass(fraxFolder.classes.itemDraggableIn)
                    }

                    if (c.attributes.draggableOutP) {
                        $t.addClass(fraxFolder.classes.itemDraggableOut)
                    }

                    let $tRemoveBtn = $t.find('.kdr-frax-folder-item-remove-btn')
                    if (c.state.checkbox_disabled == true) {
                        $tRemoveBtn.remove()
                        $tRemoveBtn.data('item', null)
                    } else {
                        $tRemoveBtn.show()
                        $tRemoveBtn.data('item', $t)
                    }

                    let $tItemsCountSpan = $t.find('.kdr-frax-folder-item-children-count')
                    if (itemsAreBigP === true && c.childrenCount != null && c.childrenCount != undefined) {
                        $tItemsCountSpan.find('.kdr-frax-folder-item-children-count-value').html(c.childrenCount)
                    } else {
                        $tItemsCountSpan.remove()
                    }

                    fraxFolder.renderNodeActionButtons($t, $t.find('.kdr-frax-folder-item-buttons'), c.nodeActionButtons, c.attributes.removableP)

                    let $imgContainer = $t.find(`.${fraxFolder.classes.itemImgContainer}`)
                    let defaultImg = $imgContainer.data('defaultImg')
                    let $img = null;

                    if (c.image.imageType != 0 && c.image.hasAnyImage() === true) {

                        if (c.image.imageType == 1 || c.image.imageType == 3) {
                            let src;
                            if (c.image.imageType == 1) {
                                src = `${window.location.origin}${__root}Frax/GetFileByMagic?p=${c.image.src}`
                            } else {
                                src = `${window.location.origin}${__root}${c.image.src}`
                            }
                            $img = $(`<img class="${fraxFolder.classes.itemImg}" src="${src}" onerror="this.src='${defaultImg}';"></img>`)
                        } else if (c.image.imageType == 2) {
                            $img = $(`<i class="${fraxFolder.classes.itemImg} ${c.image.src}"></i>`)
                        }

                    } else {
                        $img = $(`<img class="${fraxFolder.classes.itemImg}" src="${defaultImg}"></img>`)
                    }
                    $imgContainer.append($img)

                    if (itemsAreBigP === true) {
                        $imgContainer.find('.kdr-frax-folder-item-image-download').remove()
                    }

                    childsToRender.push($t)
                    allRenderedChildrens = allRenderedChildrens.add($t)
                }

                setTimeout(() => {
                    $groupRenderPlace.html(childsToRender)
                    tooltipHelper.init($groupRenderPlace, { sanitize: false })
                }, 0)
            }
            $group.find('.kdr-frax-folder-items-group-search').valExtended('')
        })

        fraxFolder.renderNoDataOverall($frax, hiddenGroupsCount == $groups.length)
        fraxFolder.initializeDragAndDropFraxFolders($frax, allRenderedChildrens);
    },
    renderNoDataOverall($frax, stateP) {
        let $container = $frax.find('.kdr-frax-folder-overall-empty')
        if ($container.length > 0) {
            if (stateP) {
                $container.show()
            } else {
                $container.hide()
            }
        }
    },
    /**
     * 
     * @param {jQuery.object} $nodeBtnsContainer
     * @param {Array<fraxNodeActionButton>} nodeActionButtons
     */renderSelectedNodeActionButtons($node, $nodeBtnsContainer, nodeActionButtons, nodeRemovableP = false) {
        $nodeBtnsContainer.html('')

        if (nodeActionButtons != null && nodeActionButtons.length != 0) {
            for (let i = nodeActionButtons.length - 1; i >= 0; i--) {
                let btn = nodeActionButtons[i]
                let $btn = $(`<button class="btn btn-sm ${btn.selectedItemClasses} ${btn.classes}"></button>`)

                if (btn.tooltip != null) {
                    $btn.attr('data-toggle', 'tooltip')
                    $btn.attr('title', btn.tooltip)
                }

                if (btn.icon != null) {
                    $btn.append(`<i class="${btn.icon}"></i>`)
                }

                $btn.data('item', $node)
                $nodeBtnsContainer.prepend($btn)
            }
            $nodeBtnsContainer.show()
        } else {
            $nodeBtnsContainer.hide()
        }

        if (nodeRemovableP === false) {
            $nodeBtnsContainer.find('.kdr-frax-folder-item-remove-btn').remove()
        }

        $nodeBtnsContainer.attr('btn-count', $nodeBtnsContainer.find('.btn').length)
    },
    /**
     * 
     * @param {jQuery.object} $nodeBtnsContainer
     * @param {Array<fraxNodeActionButton>} nodeActionButtons
     */
    renderNodeActionButtons($node, $nodeBtnsContainer, nodeActionButtons, nodeRemovableP = false) {

        if (nodeActionButtons != null && nodeActionButtons.length != 0) {
            let $template = $nodeBtnsContainer.find('.kdr-frax-folder-item-btn-template')
            for (let i = nodeActionButtons.length - 1; i >= 0; i--) {
                let btn = nodeActionButtons[i]
                let $btn = $template.clone()
                $btn.removeClass('kdr-frax-folder-item-btn-template')
                    .addClass(btn.classes)

                if (btn.tooltip != null) {
                    $btn.find('.dropdown-item-text').text(btn.tooltip)
                }

                if (btn.icon != null) {
                    $btn.find('.icon-template').replaceWith(`<i class="${btn.icon}"></i>`)
                }

                $btn.data('item', $node)
                $template.before($btn)
            }
        }

        if (nodeRemovableP === false) {
            $nodeBtnsContainer.find('.kdr-frax-folder-item-remove-btn').remove()

            if (nodeActionButtons.length == 0) {
                $nodeBtnsContainer.remove()
            }
        }
    },
    initializeDragAndDropFraxFolders($frax, childsToRender) {

        // Funkcja wywoływana przy rozpoczęciu przeciągania
        function dragStart(event) {
            fraxFolder.currentDraggableItem = this;
            if ($(this).hasClass(fraxFolder.classes.itemDraggableOut)) {
                childsToRender.each((index, element) => {
                    let $element = $(element)
                    if ($element.hasClass(fraxFolder.classes.itemDraggableIn)) {
                        $element.addClass('highlight-drag-folders');
                    }
                })
            }
        }
        function dragEnd(event) {
            childsToRender.each(function (index, element) {
                let $element = $(element)
                if ($element.hasClass('kdr-frax-folder-item-clickable')) {
                    $element.removeClass('highlight-drag-folders');
                }
            })
        }

        // Funkcje wywoływane podczas przeciągania nad obszarem upuszczania
        function dragOver(event) {
            if (($(fraxFolder.currentDraggableItem).hasClass(fraxFolder.classes.itemDraggableOut) || $(this).hasClass('drag-over')) && fraxFolder.currentDraggableItem !== this) {
                event.preventDefault();
                $element = $(this)

                if ($element.hasClass(fraxFolder.classes.itemDraggableIn)) {
                    $element.addClass('highlight-drag-folders-enter');
                }
                //escapeLogic(event);
            }
        }

        function dragEnter(event) {
            event.preventDefault();
            this.classList.add('drag-over');
            //escapeLogic(event);
        }

        function dragLeave() {
            $element = $(this)
            $element[0].classList.remove('drag-over');
            if ($element.hasClass(fraxFolder.classes.itemDraggableIn)) {
                $element.removeClass('highlight-drag-folders-enter');
            }
        }

        function escapeLogic(event) {

            var $divToEscape = $(".drag-over")

            var mouseX = event.clientX;
            var mouseY = event.clientY;

            let x = $divToEscape.getPositionInViewport()
            var divX = x.left;
            var divY = x.top;
            var distX = mouseX - divX + 10;
            var distY = mouseY - divY + 10;

            var escapeX = -distX;
            var escapeY = -distY;

            var w = window.innerWidth;
            var h = window.innerHeight;

            positionX = Math.random() * (w - x.left)
            positionY = Math.random() * (h - $divToEscape[0].offsetHeight)


            $divToEscape[0].style.transition = 'transform 0.1s ease-out';


            $divToEscape[0].style.transform = 'translate(' + positionX + 'px, ' + positionY + 'px)';
        }

        // Funkcja wywoływana podczas upuszczenia wiersza
        function drop(event) {
            event.preventDefault();
            let $draggedItem = $(fraxFolder.currentDraggableItem);
            let $dropDestination = $(this);

            let draggedP = $draggedItem.data('p')
            let targetP = $dropDestination.data('p')
            if (draggedP != targetP) {
                fraxFolder.moveItem($frax, draggedP, targetP, $frax.data('moveMagic'))
            }
        }

        childsToRender.each((index, element) => {
            let $element = $(element)

            if ($element.hasClass(fraxFolder.classes.itemDraggableOut)) {
                $element.attr('id', 'draggableItem' + (index + 1));
                $element.attr('draggable', 'true');
                $element.on('dragstart', dragStart);
                $element.on('dragend', dragEnd);
            }
            if ($element.hasClass(fraxFolder.classes.itemDraggableIn)) {
                $element.on('dragover', dragOver);
                $element.on('dragenter', dragEnter);
                $element.on('dragleave', dragLeave);
                $element.on('dragstart', dragStart);
                $element.on('drop', drop);
            }
        });

    },
    removeItem($frax, itemsPToRemove, fraxMagic) {

        let args = { selected: itemsPToRemove }

        modal.getModal.danger(
            '~{Delete}',
            '~{Are you sure you want to delete this item?}',
            false,
            '~{Cancel}',
            null,
            '~{Delete}',
            'btn-danger',
            ($modal) => {
                $.ajax({
                    type: "POST",
                    url: __root + "Frax/Act",
                    datatype: "json",
                    traditional: true,
                    data: {
                        "info": controls.getInfo($frax),
                        "magic": fraxMagic,
                        "args": JSON.stringify(args)
                    },
                    success: function (response) {
                        if (response.code == gridResponseCodes.SUCCESS) {
                            controls.onGridBeforeRender($frax, response.code, fraxActions.REMOVE, response.info, response.returnValue)
                            controls.magic(controls.getEndpoint($frax), $frax, response, $frax);

                            modalHelper.removeModalFromBody($modal)
                        } else {
                            let title = response.code == gridResponseCodes.ERROR ? __l.Error :
                                response.code == gridResponseCodes.INFO ? "~{Information}" :
                                    response.code == gridResponseCodes.WARNING ? "~{Warning}" : null;
                            modal.getModalAjax({ type: response.code, title: title, message: response.message })
                        }
                    },
                    error: function (response) {
                        let eggog = response.status + ' ' + $(response.responseText).find('.stackerror').text()
                        modal.getModal.danger(response.statusText, eggog)
                    },
                    beforeSend: function () { loading.show(); },
                    complete: function () { loading.hide(); }
                })
            }
        )
    },
    moveItem($frax, sourceItemP, targetItemP, fraxMagic) {
        let $loadingTargets = $frax

        let args = {
            sourceValue: sourceItemP,
            targetValue: targetItemP
        }

        $.ajax({
            type: "POST",
            url: __root + "Frax/Act",
            datatype: "json",
            traditional: true,
            data: {
                info: controls.getInfo($frax),
                magic: fraxMagic,
                args: JSON.stringify(args)
            },
            success: function (response) {
                if (response.info == null) {
                    response.info = controls.getInfo($frax)
                }

                controls.magic(controls.getEndpoint($frax), $frax, response, $loadingTargets, true);
            },
            beforeSend: function () { loading.show($loadingTargets) },
            complete: function () { loading.hide($loadingTargets) }
        });
    },
    searchGroupForItems(searchValue, $groupContainer) {
        let $searchItems = $groupContainer.find('.kdr-frax-folder-item')
        if (textHelper.isNullOrEmpty(searchValue)) {
            $searchItems.show()
        } else {
            let sss = searchValue.trim().toLowerCase().split(',')
            let ss = []
            for (var i = 0; i < sss.length; i++) {
                let s = sss[i].trim()
                if (textHelper.isNullOrEmpty(s) === false) {
                    ss.push(s)
                }
            }

            for (var i = 0; i < $searchItems.length; i++) {
                let $si = $searchItems.eq(i)
                let nameText = $si.find('.kdr-frax-folder-item-name').text().trim().toLowerCase()
                if (ss.some(s => nameText.includes(s))) {
                    $si.show()
                } else {
                    $si.hide()
                }
            }
        }
    },
}

$.fn.fraxFolderInit = function () {
    let $f = $(this)
    try {
        let selectedNode = fraxFolder.getSelectedNode($f)
        let selectedNodeId;

        if (selectedNode != undefined) {
            selectedNodeId = selectedNode.id
        }

        fraxFolder.selectNode($f, selectedNodeId, false)

        controls.onGridAfterUiInit($f, gridResponseCodes.SUCCESS, null)
    } catch (exception) {
        console.info('Error at frax folder init, fraxId: ', $f.prop('id'))
        console.error(exception)
    }
}
$.fn.fraxFolderSelectNode = function () {
    let $selectedItem = $(this)
    let $fraxFolder = $selectedItem.closest('.kdr-frax-folder')
    let p = $selectedItem.data('p');

    fraxFolder.selectNode($fraxFolder, p)
}
$.fn.fraxFolderGetSelectedNodeValue = function () {
    let $fraxFolder = $(this)
    return fraxFolder.getSelectedNodeValue($fraxFolder)
}
$.fn.fraxFolderRemoveItem = function (nodeMagic, magic) {
    let $fraxFolder = $(this)
    let itemP = [nodeMagic]
    return fraxFolder.removeItem($fraxFolder, itemP, magic)
}
$.fn.fraxFolderFindInGroup = function (searchValue, $groupContainer) {
    fraxFolder.searchGroupForItems(searchValue, $groupContainer)
}
$.fn.fraxFolderNodeDownloadFile = function (nodeMagic) {
    let $fraxNode = $(this)
    let $fraxFolder = $fraxNode.closest('.kdr-frax-folder')
    return fraxFolder.removeItem($fraxFolder, nodeMagic)
}

$(document).on('dblclick', '.kdr-frax-folder .kdr-frax-folder-item-clickable', function (e) {
    if ($(e.target).hasClass('kdr-frax-folder-item-action-btn') === false) {
        let $item = $(this)
        $item.fraxFolderSelectNode()
    }
})
$(document).on('click', '.kdr-frax-folder .kdr-frax-folder-breadcrumb:not(.kdr-frax-folder-breadcrumb-ignore)', function () {
    let $item = $(this)
    $item.fraxFolderSelectNode()
})
$(document).on('click', '.kdr-frax-folder .kdr-frax-folder-item-remove-btn', function () {
    let $btn = $(this)
    let itemMagic = $btn.data('item').data('p')
    let magic = $btn.data('magic')
    $btn.closest('.kdr-frax-folder').fraxFolderRemoveItem(itemMagic, magic)
})
$(document).on(fraxEvents.SELECTED, '.kdr-frax-folder', function () {
    controls.invokeCommands($(this))
})
$(document).on('click', '.kdr-frax-folder .kdr-frax-folder-items-group-search-container .btn-search', function () {
    $(this).closest('.kdr-frax-folder-items-group-search-container').find('.kdr-frax-folder-items-group-search').focus()
})
$(document).on('paste input', '.kdr-frax-folder .kdr-frax-folder-items-group-search-container .kdr-frax-folder-items-group-search', function () {
    let $input = $(this)
    let $group = $input.closest('.kdr-frax-folder-items-group')
    let $frax = $input.closest('.kdr-frax-folder')
    $frax.fraxFolderFindInGroup($input.valExtended(), $group)
})
$(document).on('click', '.kdr-frax-folder .kdr-frax-folder-item-download, .as-search-results-element-article.as-search-results-download-file', function (e) {
    if ($(e.target).closest('.dropdown').length == 0) {

        let $item = $(this).closest('.kdr-frax-folder-item')
        let $frax

        if ($item.length < 1) {
            $item = $(this)
            $frax = $('.kdr-frax-folder')
        } else {
            $frax = $item.closest('.kdr-frax-folder')
        }


        $item.trigger(fraxFolder.events.downloadFraxFolderItem, [$frax])
    }
})

$("#document-structures").ready(function () {

    $("#left-ds-frax").ready(function () {
        Frax.initialize("left-ds-frax");
        Frax.registerSelectionCallback("left-ds-frax", function (evt, data, mode) {
            $('.kdr-filters[data-control-id=document-structures-details] #id').val(data.node.id);
            $('.kdr-filters[data-control-id=document-structures-details] .kdr-filters-btn').last().click();
            $('.document-structure-element').html(data.node.text);
        });

    });
    $("#right-ds-frax").ready(function () {
        Frax.initialize("right-ds-frax");
        Frax.registerSelectionCallback("right-ds-frax", function (evt, data, mode) {
            $('.kdr-filters[data-control-id=document-structures-details] #id').val(data.node.id);
            $('.kdr-filters[data-control-id=document-structures-details] .kdr-filters-btn').last().click();
            $('.new-document-structure-element').html(data.node.text);
        });

    });
    $(document).on("click", ".document-structures-action-commit", function (e) {
        loading.show($('.body-content'));
        let payload = {
            document_from: Frax.getSelected('left-ds-frax')[0],
            document_to: Frax.getSelected('right-ds-frax')[0],
            date_from: $('.time-from input').val(),
            date_to: $('.time-to input').val(),
        };
        $.ajax({
            type: "POST",
            url: __root + "Administration/CommitDocument",
            datatype: "json",
            traditional: true,
            data: {
                "payload": JSON.stringify(payload)
            },
            success: function (response) {
                location.reload(true)
            }
        })
    });
});

const fraxArticle = {
    openFolder($frax, fraxMagic, targetItemP) {
        let $loadingTargets = $frax

        let args = {
            targetValue: targetItemP
        }

        $.ajax({
            type: "POST",
            url: __root + "Frax/Act",
            datatype: "json",
            traditional: true,
            data: {
                info: controls.getInfo($frax),
                magic: fraxMagic,
                args: JSON.stringify(args)
            },
            success: function (response) {
                if (response.info == null) {
                    response.info = controls.getInfo($frax)
                }

                controls.magic(controls.getEndpoint($frax), $frax, response, $loadingTargets, true);
            },
            beforeSend: function () { loading.show($loadingTargets) },
            complete: function () { loading.hide($loadingTargets) }
        });
    },
    searchHandler($this) {
        let $control = $('.kdr-frax-folder')
        let $selectedCategory = $this.closest('.kb-search-container').find('.kb-search-container-btn-selected').data('p')
        let v = $this.valExtended().toLowerCase().trim();
        //let $control = $('#' + $this.attr('control-id'))


        let $container, $questionsPartialContainer

        $questionsPartialContainer = $('.as-search-results')


        //let $counter = $container.find('#hc-questions-counter')
        //let $counterCount = $container.find('#hc-questions-counter #hc-counter-count')
        if (v === '' || !v) {
            if ($control.length > 0) {
                $control.show();
                $questionsPartialContainer.hide();
            }
            else {
                //let $children = $container.children();
                //$children.find('.found-answear-text').html('')
                //$allQuestionsItems.show();
                //$counterCount.text($allQuestionsItems.length)
            }
        }
        else {
            $questionsPartialContainer.show()
            $control.hide();
            let a = v
            //let matchStrign = ''
            //for (var i = 0; i < v.length; i++) {
            //    if (/[.,!@#$%^&*]/g.test(v[i])) {
            //    }
            //    else if (v[i] == ' ') {
            //        matchStrign += v[i]
            //        a += '.*'
            //    } else {
            //        matchStrign += `${v[i]}`
            //        a += `${v[i]}`
            //    }
            //}

            //var regex = new RegExp(a, 'gmi')

            switch ($selectedCategory) {
                case 1:
                    $hits = fraxFolder.getStructure($control).filter(x => (x.text.toLowerCase().includes(a)))
                    break;
                case 2:
                    $hits = fraxFolder.getStructure($control).filter(x => (x.description && x.description.toLowerCase().includes(a)))
                    break;
                case 3:
                    $hits = fraxFolder.getStructure($control).filter(x => (x.content.toLowerCase().includes(a)))
                    break;
                case 4:
                    $hits = fraxFolder.getStructure($control).filter(x => (x.fileNames.toLowerCase().includes(a)))
                    break;
                case 5:
                    $hits = fraxFolder.getStructure($control).filter(x => (x.text.toLowerCase().includes(a)))
                    break;
                case 6:
                    $hits = fraxFolder.getStructure($control).filter(x => (x.description && x.description.toLowerCase().includes(a)))
                    break;
                default:
                    $hits = fraxFolder.getStructure($control).filter(x => (x.text.toLowerCase().includes(a) || (x.description && x.description.toLowerCase().includes(a))))
                    break;

            }

            if ($hits) {
                if ($hits.length > 0) {
                    $('.as-search-results-empty-data').addClass('hide')
                    $('.as-search-results-data').removeClass('hide')

                    var $template = $questionsPartialContainer.find('.as-search-results-element-template')
                    var $foldersParent = $questionsPartialContainer.find('.as-search-results-folders').empty().hide()
                    var $articlesParent = $questionsPartialContainer.find('.as-search-results-articles').empty().hide()

                    let $foldersCounter = $questionsPartialContainer.find('.as-search-results-header-counter-folders').text(0)
                    let $articlesCounter = $questionsPartialContainer.find('.as-search-results-header-counter-articles').text(0)

                    for (let i = 0; i < $hits.length; i++) {

                        let folderP = ($hits[i].groupKey == 0) ? true : false;

                        if (folderP) {
                            if ($hits[i].outerClass && $hits[i].outerClass.includes('kdr-frax-folder-new-catalog')) {
                                continue
                            }

                            let $element = $template.clone().removeClass('as-search-results-element-template').addClass('as-search-results-element').addClass('as-search-results-element-folder').data('p', $hits[i].id)
                            $element.find('.as-search-results-element-image-folder').toggleClass('hide')
                            $element.find('.as-search-results-element-title').html($hits[i].text)
                            $element.find('.as-search-results-element-subtitle').html($hits[i].description)

                            $element.find('.dropdown-item').data('item', $element)

                            $questionsPartialContainer.find('.as-search-results-header-counter-folders').text(parseInt($foldersCounter.text()) + 1)

                            $foldersParent.append($element)
                        } else {
                            if ($hits[i].outerClass && $hits[i].outerClass.includes('kdr-frax-folder-new-article')) {
                                continue
                            }

                            let $element = $template.clone().removeClass('as-search-results-element-template').addClass('as-search-results-element').addClass('as-search-results-element-article').data('p', $hits[i].id)
                            $element.find('.as-search-results-element-image-article').toggleClass('hide')
                            $element.find('.as-search-results-element-title').html($hits[i].text)
                            $element.find('.as-search-results-element-path').html($hits[i].path)
                            $element.find('.fa-folder-tree').css('display', 'block')
                            $element.find('.as-search-results-element-subtitle').html($hits[i].description)

                            $element.find('.article-structure-article-move-to-folder').data('parent', $hits[i].parent)

                            $element.find('.dropdown-item').data('item', $element)

                            $questionsPartialContainer.find('.as-search-results-header-counter-articles').text(parseInt($articlesCounter.text()) + 1)

                            $articlesParent.append($element)
                        }
                    }

                    if ($foldersParent.children().length > 0) {
                        $foldersParent.show()
                    }

                    if ($articlesParent.children().length > 0) {
                        $articlesParent.show()
                    }
                } else {
                    $('.as-search-results-empty-data').removeClass('hide')
                    $('.as-search-results-data').addClass('hide')
                }
            }
        }
    }
}

$(document).on('dblclick', '.kdr-frax-article-item-big', function (e) {
    let $this = $(this)
    let $parent = $this.closest('.kdr-frax-folder')

    fraxArticle.openFolder($parent, $parent.data('move-magic'), $this.data('p'));
})

$(document).on('paste input', '#as-search-input', function () {
    fraxArticle.searchHandler($('#as-search-input'));
})

$(document).on('click', '.kdr-frax-folder-breadcrumb-parent-dots', function (e) {
    $('.kdr-frax-folder-breadcrumbs').toggleClass('kdr-frax-folder-breadcrumbs-short')
})

$(document).on('click', '.kdr-frax-folder-sort-value', function (e) {
    e.preventDefault()

    let $this = $(this)
    let $parent = $this.closest('.kdr-frax-folder')
    let p = $this.data('p')

    $.ajax({
        type: "POST",
        url: __root + "Frax/FraxFolderSort",
        datatype: "json",
        traditional: true,
        data: {
            info: controls.getInfo($parent),
            p: p
        },
        success: function (response) {
            controls.setInfo($parent, response.info)
            controls.refresh($parent)
        },

        beforeSend: function () { $parent && loading.show($parent) },
        complete: function () { $parent && loading.hide($parent) }
    })
})
//#endregion Frax